const SET_TAG = 'SET_TAG'

export { SET_TAG }
